import o from "react";
import { upperFirst as b } from "lodash";
import i from "classnames";
import t from "prop-types";
import { g as B } from "./utils-Ci4OZEP4.es.js";
import { D as y } from "./DarkModeProvider-xoZXm3ct.es.js";
import { T as k } from "./index-Dd-4N6BE.es.js";
import { u as v } from "./ThemeProvider--i7ESlT5.es.js";
import './Badge2.css';const w = "#ac2f96", $ = "#cb0b16", E = "Badge-default-module__container___iHlNe", N = "Badge-default-module__badge___ySyYA", P = "Badge-default-module__before___AAG88", S = "Badge-default-module__counterBadge___BJUt4", m = {
  beta: w,
  "new-data": "#99e6b3",
  "new-feature": "#fedb00",
  counter: $,
  container: E,
  badge: N,
  before: P,
  counterBadge: S
}, T = "Badge-compere-module__beta___YPhus", h = "#cb0b16", x = "Badge-compere-module__container___XI0JG", C = "Badge-compere-module__badge___udxpi", D = "Badge-compere-module__before___yvDXv", A = "Badge-compere-module__counterBadge___ZLPmS", M = {
  beta: T,
  "new-data": "#cf0",
  "new-feature": "#00ffe1",
  counter: h,
  container: x,
  badge: C,
  before: D,
  counterBadge: A
}, G = {
  default: m,
  compere: M
}, _ = ({ children: c, position: u, type: a, color: l }) => {
  const r = v(), e = G[r] || m, f = u === "before", d = r === "compere" && a === "beta", g = i(
    e.badge,
    d && e.beta,
    f && e.before,
    a === "counter" && e.counterBadge
  ), p = r === "default" ? b(c) : c, s = l || e[a];
  let n;
  return d ? n = !0 : n = B(s, "Badge"), /* @__PURE__ */ o.createElement("span", { className: e.container }, /* @__PURE__ */ o.createElement(
    "span",
    {
      className: g,
      style: { backgroundColor: s }
    },
    /* @__PURE__ */ o.createElement(y, { darkMode: n }, /* @__PURE__ */ o.createElement(k.Body3, { responsive: !0, tagName: "span" }, /* @__PURE__ */ o.createElement("strong", null, p)))
  ));
};
_.propTypes = {
  /** The text content of the badge */
  children: t.string.isRequired,
  /** Whether the badge is placed before or after its sibling */
  position: t.oneOf(["before", "after"]),
  /** What the badge indicates. Dictates color of the text and background */
  type: t.oneOf(["beta", "new-data", "new-feature", "counter"]),
  /** color of badge if type is 'undefined' */
  color: t.string
};
_.defaultProps = {
  position: "after",
  type: void 0,
  color: void 0
};
export {
  _ as B
};
